// @flow

import * as React from 'react';
import {useContext, useState} from 'react';
import {contextStubFunction} from 'docs/util';

export type SequenceDiagramContextType = {
  height: number,
  setHeight: (number) => void,
  segmentWidth: number,
  setSegmentWidth: (number) => void,
};

const SequenceDiagramContext = React.createContext<SequenceDiagramContextType>({
  height: 0,
  setHeight: contextStubFunction('SequenceDiagram'),
  segmentWidth: 0,
  setSegmentWidth: contextStubFunction('SequenceDiagram'),
});

type SequenceDiagramProviderProps = {|
  children: React.Node,
|};

export const SequenceDiagramProvider = (
  props: SequenceDiagramProviderProps,
) => {
  const [height, setHeight] = useState(0);
  const [segmentWidth, setSegmentWidth] = useState(0);

  const value = {
    height,
    setHeight,
    segmentWidth,
    setSegmentWidth,
  };
  return (
    <SequenceDiagramContext.Provider value={value}>
      {props.children}
    </SequenceDiagramContext.Provider>
  );
};

export const useSequenceDiagram = () => {
  return useContext(SequenceDiagramContext);
};
